import { THEME_CHANGED } from "../constants";

// Use browser setting if available
const isDark: any = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
const defaultTheme = isDark ? (isDark.matches ? "dark" : "light") : "dark";

const initial_state = {
  loading: false,
  theme: defaultTheme, // light | dark
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function Settings(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case THEME_CHANGED:
      return {
        theme: payload,
      };

    default:
      return state;
  }
}
